import { seo, pageTitle } from '@shared/seo.config'

interface SeoProps {
  title?: string
  description?: string
  /** Ảnh riêng cho trang này; bỏ trống thì dùng ảnh mặc định của website. */
  image?: string
  /** Đặt true cho trang không muốn lên kết quả tìm kiếm (ví dụ trang quản trị). */
  noIndex?: boolean
}

/**
 * Thẻ meta cho MỘT trang. Đặt <Seo title="..." /> ở đầu mỗi page component.
 *
 * React 19 tự nâng <title>/<meta>/<link> lên <head> dù chúng được render ở bất
 * cứ đâu trong cây — nên không cần react-helmet hay thư viện nào khác.
 *
 * Lưu ý: thẻ ở đây chỉ tồn tại SAU khi JavaScript chạy. Crawler của AI phần lớn
 * không chạy JavaScript — phần cho họ do Worker chèn sẵn vào HTML
 * (server/seo/index.ts). Hai đường bổ trợ nhau, đừng bỏ đường nào.
 */
export function Seo({ title, description, image, noIndex }: SeoProps) {
  const full = pageTitle(title)
  const desc = description ?? seo.description
  const img = image ?? seo.ogImage
  return (
    <>
      <title>{full}</title>
      <meta name="description" content={desc} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:title" content={full} />
      <meta property="og:description" content={desc} />
      <meta property="og:site_name" content={seo.siteName} />
      {img && <meta property="og:image" content={img} />}
      <meta name="twitter:card" content="summary_large_image" />
    </>
  )
}
